<template>
  <div class="container">
    <h3 class="text-center">
      Demandez gratuitement une démonstration
      <strong class="live">live</strong> de Livratos
    </h3>
    <!--Section: Content-->
    <div class="mb-5 contactUs">
      <!-- Grid row -->
      <div class="row">
        <div class="col-12">
          <div class="card z-depth-2">
            <div class="card-body p-0">
              <div class="row mx-0 contactUs__first">
                <div class="col-lg-6 black rounded-left py-5 px-md-5 call-me">
                  <div>
                    <a href="tel:+33788973267" class="footer-icon">
                      <i class="fas fa-phone mx-2"></i>
                    </a>
                    <a href="sms:+33788973267" class="footer-icon">
                      <i class="fa fa-comments mx-2"> </i>
                    </a>
                    <a href="mailto:contact@livratos.fr" class="footer-icon">
                      <i class="fa fa-envelope mx-2"> </i>
                    </a>
                  </div>
                </div>
                <div
                  class="contactUs__second col-lg-6 red accent-3 rounded-right"
                >
                  <img
                    src="@/assets/brand/logo-nav-black.webp"
                    alt="logo livratos"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Grid row -->
    </div>
    <!--Section: Content-->
  </div>
</template>

<script>
export default {
  name: "ContactUsAction",
};
</script>

<style lang="scss" scoped>
.contactUs {
  &:hover {
    & h3 {
      color: $color-text;
      & span {
        color: $color-primary;
        font-weight: bolder;
      }
    }
  }

  &__first {
    display: flex;
    justify-content: center;
    align-items: stretch;
    background: transparent; // on laisse chaque moitié gérer son fond

    .call-me {
      background-color: black !important; // colonne gauche noire
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;

      @media screen and (min-width: 992px) {
        justify-content: space-evenly;
      }

      .footer-icon {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin: 0 0.4rem;
      }

      i {
        font-size: 42px;
        color: $color-primary;
        background: rgba($color-secondary, 0.3);
        padding: 9px;
        border-radius: 10px;

        @media screen and (min-width: 992px) {
          font-size: 50px;
        }
      }
    }
  }

  &__second {
    background-color: #ffffff !important; // 👉 partie droite blanche
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.5rem;

    img {
      max-width: 220px;
      width: 100%;
      height: auto;
      display: block;
    }
  }
}
.live {
  color: $color-primary;
  font-weight: bolder !important;
}
</style>
